import Vue from 'vue'
import Vuex from 'vuex'

import sng from './module/sng'
import login from './module/login'
import union from './module/union'
import club from './module/club'
import jackpot from './module/jackpot'
import jpbAccount from './module/jpbAccount'
import managementMsg from './module/managementMsg'
import user from './module/user'
import gameDetail from './module/gameDetail'
import mttBanner from './module/mttBanner'
import functionSwitchConfig from './module/functionSwitchConfig'
import authUsers from './module/authUsers'
import market from './module/market'
import accountPayee from './module/accountPayee'
import accountPayeeCheck from './module/accountPayeeCheck'
import product from './module/product'
import network from './module/network'
import maintain from './module/maintain'
import dataManage from './module/dataManage'
import system from './module/system'
import payChannel from './module/payChannel'
import messages from './module/messages'
import rechargeOrder from './module/rechargeOrder'
import escrowSupports from './module/escrowSupports'
import warehouseAcquisitions from './module/warehouseAcquisitions'
import at from './module/at'
import rankReward from './module/RankReward'
import pumping from './module/pumping'
import other from './module/other'
import withdrawChip from './module/withdrawChip'
import manualRechargeUserChip from './module/manualRechargeUserChip'
import manualRechargePayChannelChip from './module/manualRechargePayChannelChip'
import manualRecharge from './module/manualRecharge'
import mallPayChannel from './module/mallPayChannel'
import audit from './module/audit'
import userOnline from './module/userOnline'
import complaint from './module/complaint'
import activity from './module/activity'
import channelRecord from './module/channelRecord'
import platformReport from './module/platformReport'
import beanApi from './module/beanApi'
import mtt from './module/mtt'
import cardControl from './module/cardControl'
import integral from "./module/integral";
import gameConfigure from "./module/gameConfigure";
import userLeaveTable from "./module/userLeaveTable";
import rankingAward from "./module/rankingAward";
import mangZhuGrade from "./module/mangZhuGrade";

Vue.use(Vuex)

const modules = {
    sng,
    login,
    union,// 联盟
    club,// 俱乐部
    integral,
    jackpot,//jp
    jpbAccount,//jpb仓库
    managementMsg,// 消息管理
    user,//玩家
    gameDetail,// 牌局信息
    mttBanner,// 轮播图相关
    functionSwitchConfig,// 系统配置
    authUsers,// 用户权限
    market,// 营销账户管理
    accountPayee,// 提豆管理
    accountPayeeCheck,// 提豆信息审核
    product,// 商城-商品配置
    network,// 网络切换
    maintain,// 维护消息内容
    dataManage,// 数据管理
    system,// 系统管理
    payChannel,// 代充渠道
    messages,// 消息
    rechargeOrder,// 充值订单查询
    escrowSupports,// 支付切换
    warehouseAcquisitions,// 仓库采集
    at,// AT配置管理
    pumping,//抽水管理
    mangZhuGrade,
    rankingAward,
    other,// 短信
    withdrawChip, //金豆申请列表
    manualRechargeUserChip,// 手动充豆给用户
    manualRechargePayChannelChip,// 手动充豆给代充渠道仓
    manualRecharge,// 手工充值仓
    mallPayChannel,// 商城支付通道配置
    audit,// 审计管理
    userOnline,// 在线玩家
    complaint,// 伙牌投诉
    activity,// 活动模块
    channelRecord,// 推广模块
    platformReport,// 平台报表
    beanApi,//金豆提现申请
    mtt,//mtt
    cardControl,
    userLeaveTable,
    gameConfigure,
    rankReward
};


export default new Vuex.Store({
    modules,
})